'use client'

import Image from 'next/image'
import Flickity from 'react-flickity-component'

import cheffWithCake from '../../../../public/cheff-with-cake.webp'

import { Comment } from '@/components/Comment'
import {
  DELIVERY_RADIUS_KM,
  MIN_NOTICE_DAYS,
  SERVED_NEIGHBORHOODS,
} from '@/config/constants'
import { COMMENTS } from '../../../config/comments'

import { useBreakpoints } from '@/hooks'
import './styles.scss'

export default function About() {
  const { isSmall, isSemiMedium } = useBreakpoints()

  return (
    <section
      className="about container"
      id="about"
      aria-labelledby="about-heading"
    >
      {/* Import estático: o Next deriva width/height reais e gera o blur
          automaticamente. Antes, blurDataURL apontava para o próprio PNG de
          1,9 MB, que era baixado sem otimização como placeholder. */}
      <Image
        src={cheffWithCake}
        alt="Confeiteira da Sancta Fatia segurando bolo artesanal decorado"
        className="about__cheff__main-image"
        placeholder="blur"
        sizes="(max-width: 669px) 20vw, 400px"
      />

      <div className="about__content">
        <div className="about__content__company">
          <h2 id="about-heading">a Sancta Fatia</h2>
          <p>
            Somos uma confeitaria de bolos e doces artesanais da Zona Leste de
            São Paulo. Nascemos em 2023 com o objetivo de oferecer produtos de
            alta qualidade, atendimento de excelência e ambiente intuitivo para
            se fazer pedidos.
          </p>
          <p>
            Trabalhamos por encomenda, a partir da nossa cozinha no Jardim Nossa
            Senhora do Carmo, no distrito do Parque do Carmo. Cada bolo
            confeitado é feito para a data do pedido — nada fica pronto
            esperando na prateleira, e por isso pedimos no mínimo{' '}
            {MIN_NOTICE_DAYS} dias de antecedência.
          </p>
          <p>
            Entregamos num raio de {DELIVERY_RADIUS_KM} km, o que cobre boa
            parte da Zona Leste: {SERVED_NEIGHBORHOODS.slice(0, -1).join(', ')}{' '}
            e {SERVED_NEIGHBORHOODS[SERVED_NEIGHBORHOODS.length - 1]}. A taxa é
            calculada pela distância até o seu endereço, e você vê o valor antes
            de fechar o pedido.
          </p>
        </div>

        <div className="about__content__comments">
          <Flickity
            elementType="div"
            options={{
              pageDots: false,
              draggable: true,
              prevNextButtons: false,
              cellAlign: isSmall ? 'left' : isSemiMedium ? 'center' : 'left',
              percentPosition: true,
            }}
            disableImagesLoaded
          >
            {COMMENTS.map((comment, idx) => (
              <Comment
                key={JSON.stringify(comment.text) + Math.random()}
                date={comment.date}
                name={comment.name}
                text={comment.text}
                photoUrl={comment.photoUrl}
                style={{ marginLeft: idx > 0 ? 20 : 0 }}
              />
            ))}
          </Flickity>
        </div>
      </div>
    </section>
  )
}
